module.exports = __webpack_public_path__ + "static/media/tasks-icon.2facc30b.svg";